import React, { useEffect, useReducer, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { CreateLead, CrudLayout } from 'ui/components';
import { Table } from 'ui/atoms';
import { MODAL_OPEN } from 'redux/slices/modals';

import DownloadReportModal from 'ui/components/Modals/DownloadReportModal';
import { columnDetails } from './columnDetails';
import {
  partnerRoles,
  SortDirection,
  StatusLeadOptions,
  TypeLeadOptions
} from 'const';
import {
  DOWNLOAD_LEAD_LIST,
  GET_LEAD_LIST,
  UPDATE_LEAD_STATUS
} from 'redux/sagas/actions/lead';
import {
  RESET_ADVANCED_SEARCH_FILTERS,
  SET_FILTER,
  SET_SEARCH_PATTERN,
  SET_SELECTED_COUNTRIES,
  SET_SELECTED_STATUS_OPTIONS,
  SET_SELECTED_TYPES,
  SET_SORT_DATA
} from 'redux/slices/lead';
import { isCommercialRole } from '../../utils/common';
import { TOGGLE_SIDEBAR } from '../../redux/slices/sidebar';

export const actions = {
  SET_NAME: 'set_name',
  SET_LAST_NAME: 'set_last_name',
  SET_EMAIL: 'set_email'
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_NAME:
      return {
        ...state,
        name: action.payload
      };
    case actions.SET_LAST_NAME:
      return {
        ...state,
        surname: action.payload
      };
    case actions.SET_EMAIL:
      return {
        ...state,
        email: action.payload
      };
    default:
      return state;
  }
};

const initialState = {
  name: '',
  surname: '',
  email: ''
};

const Lead = ({
  isLoading,
  leadList,
  getLeadList,
  openDownloadReportModal,
  totalPages,
  pageSize,
  pageNo,
  totalRecords,
  searchPattern,
  setSearchPattern,
  setSelectedStatusOptions,
  setSelectedTypes,
  setSortData,
  sortBy,
  sortDirection,
  role,
  setFilter,
  toggleSidebar,
  returnedRecords,
  updateLeadStatus,
  downloadLeadList,
  setSelectedCountries,
  resetAdvancedSearch,
  isSidebarOpen
}) => {
  const { t } = useTranslation();
  const [advancedSearchValues, dispatch] = useReducer(reducer, initialState);
  const [headerColumns, setHeaderColumns] = useState(columnDetails);
  const [resetSelection, setResetSelection] = useState(false);
  /*  const [errorEmail, setErrorEmail] = useState('');

  useEffect(() => {
    if (
      advancedSearchValues?.email &&
      !validator(RegexpType.EMAIL, advancedSearchValues.email)
    ) {
      setErrorEmail('email_error');
    } else {
      setErrorEmail('');
    }
  }, [advancedSearchValues.email]);*/

  useEffect(() => {
    return () => {
      setSelectedStatusOptions([]);
      setSelectedTypes([]);
      resetAdvancedSearch();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const invokeCorrectGetData = (page, size) => {
    getLeadList(page || 0, size || 10);
  };

  useEffect(() => {
    setSearchPattern('');
    invokeCorrectGetData();
    /*const filteredColumn =
      role === partnerRoles.ADMIN
        ? columnDetails
        : columnDetails.filter(column => column.accessor !== 'dealerCountry');

    setHeaderColumns(filteredColumn);*/
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getLeadList, setSearchPattern]);

  const fetchAccountsByPage = (pageNumber, pageSizeValue) => {
    handleSetFilter('pageNo', pageNumber);
    handleSetFilter('pageSize', pageSizeValue);
    invokeCorrectGetData(pageNumber, pageSizeValue);
  };

  const onSortByColumn = columnName => {
    setSortData(columnName);
    invokeCorrectGetData(0, pageSize);
  };

  const onSubmitAdvancedSearch = () => {
    setResetSelection(true);
    for (const filter in advancedSearchValues) {
      handleSetFilter(filter, advancedSearchValues[filter]);
    }
    invokeCorrectGetData(0, pageSize);
  };

  const onDropdownChange = selected => {
    setResetSelection(true);
    setTimeout(() => setResetSelection(false), 100);
    setSelectedTypes(selected?.type?.map(row => row.value));
    setSelectedStatusOptions(selected?.status?.map(row => row.value));
    setSelectedCountries(selected?.country?.map(row => row.value));
    invokeCorrectGetData(0, pageSize);
  };

  const handleSetFilter = (name, value) => {
    setFilter({ [name]: value });
  };

  useEffect(() => {
    const filteredColumn = isSidebarOpen
      ? columnDetails.filter(
          column =>
            column.accessor === 'leadId' ||
            column.accessor === 'type' ||
            column.accessor === 'email' ||
            column.accessor === 'createdOn'
        )
      : role === partnerRoles.ADMIN
      ? columnDetails
      : columnDetails.filter(column => column.accessor !== 'dealerCountry');
    setHeaderColumns(filteredColumn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSidebarOpen]);

  const onStatusClick = rowData => {
    updateLeadStatus({
      leadIds: [rowData.leadId],
      targetStatus: 'NOT_INTERESTED'
    });
  };

  const generalDropDown = [
    {
      options: StatusLeadOptions(),
      placeholder: t('status'),
      menuWidth: 250,
      isMulti: true,
      checkBoxMenu: true,
      isClearable: false,
      detachedOptions: true,
      name: 'status',
      resetSelection: true
    },
    {
      options: TypeLeadOptions(),
      placeholder: t('type'),
      menuWidth: 250,
      isMulti: true,
      checkBoxMenu: true,
      isClearable: false,
      detachedOptions: true,
      name: 'type',
      resetSelection: true
    }
  ];

  const onCloseAdvancedSearch = () => {
    //resetAdvancedSearch();
    if (
      !advancedSearchValues?.name &&
      !advancedSearchValues?.surname &&
      !advancedSearchValues?.email
    ) {
      resetAdvancedSearch();
      invokeCorrectGetData(0, pageSize);
    }
  };

  return (
    <CrudLayout
      title={t('lead')}
      description={t('lead_description')}
      /* dropdowns={role === partnerRoles.ADMIN ? adminDropDown : generalDropDown}*/
      dropdowns={generalDropDown}
      onSubmitDropdown={onDropdownChange}
      advancedSearchFields={[
        {
          name: 'name',
          actionType: actions.SET_NAME
        },
        { name: 'surname', actionType: actions.SET_LAST_NAME },
        { name: 'email', actionType: actions.SET_EMAIL }
      ]}
      advancedSearchValues={advancedSearchValues}
      onSubmitAdvancedChange={(value, actionType) => {
        dispatch({
          type: actionType,
          payload: value
        });
      }}
      onSubmitAdvancedSearch={onSubmitAdvancedSearch}
      Sidebar={isCommercialRole(role) && CreateLead}
      onDownloadCsv={() => openDownloadReportModal()}
      // callbackSidebar={onSidebarToggle}
      resetAdvancedSearch={onCloseAdvancedSearch}
    >
      <>
        <Table
          headerColumns={headerColumns}
          data={leadList}
          isLoading={isLoading}
          totalPages={totalPages}
          totalRecords={totalRecords}
          onPageChangeFetch={fetchAccountsByPage}
          pageNo={pageNo}
          pageSize={pageSize}
          pagination
          itemPropForSelection="leadId"
          onSortByColumn={onSortByColumn}
          sortingInfo={{
            sortingDirection: sortDirection || SortDirection.ASC,
            sortingOn: sortBy
          }}
          selection
          onStatusClick={onStatusClick}
          updateLeadsStatus={updateLeadStatus}
          isLeadsList
          resetSelection={resetSelection}
          role={role}
        />
        <DownloadReportModal isLead />
      </>
    </CrudLayout>
  );
};

Lead.propTypes = {
  openDownloadReportModal: PropTypes.func,
  getLeadList: PropTypes.func,
  leadList: PropTypes.array,
  isLoading: PropTypes.bool,
  totalPages: PropTypes.number,
  totalRecords: PropTypes.number,
  pageSize: PropTypes.number,
  pageNo: PropTypes.number,
  searchPattern: PropTypes.string,
  setSearchPattern: PropTypes.func,
  setSelectedStatusOptions: PropTypes.func,
  setSelectedTypes: PropTypes.func,
  setSelectedCountries: PropTypes.func,
  sortBy: PropTypes.string,
  role: PropTypes.string,
  setFilter: PropTypes.func,
  sortDirection: PropTypes.string,
  returnedRecords: PropTypes.number,
  toggleSidebar: PropTypes.func,
  updateLeadStatus: PropTypes.func,
  downloadLeadList: PropTypes.func,
  resetAdvancedSearch: PropTypes.func,
  isSidebarOpen: PropTypes.bool
};

export default connect(
  state => ({
    leadList: state?.lead?.leads || [],
    isLoading: state?.lead?.isLoading,
    totalPages: state?.lead?.totalPagesAvailable || 0,
    pageNo: state?.lead?.pageNo,
    totalRecords: state?.lead?.totalRecords,
    selectedStatusOptions: state?.lead?.selectedStatuses,
    searchPattern: state?.lead?.searchPattern,
    sortBy: state?.lead?.sortBy,
    sortDirection: state?.lead?.sortDirection,
    role: state?.authentication?.role,
    pageSize: state?.lead?.pageSize,
    returnedRecords: state?.lead?.returnedRecords,
    isSidebarOpen: state?.sidebar?.sidebarOpen
  }),
  dispatch => ({
    openDownloadReportModal: () =>
      dispatch(MODAL_OPEN({ id: 'DownloadReportModal' })),
    getLeadList: (pageNo, pageSize) =>
      dispatch({
        type: GET_LEAD_LIST._REQUEST,
        payload: { pageNo, pageSize }
      }),
    searchAccountsByPattern: (pageNo, pageSize, pattern) => dispatch({}),
    setSelectedTypes: type => dispatch(SET_SELECTED_TYPES(type)),
    setSelectedStatusOptions: status =>
      dispatch(SET_SELECTED_STATUS_OPTIONS(status)),
    setSelectedCountries: country => dispatch(SET_SELECTED_COUNTRIES(country)),
    setSearchPattern: searchPattern =>
      dispatch(SET_SEARCH_PATTERN(searchPattern)),
    setSortData: sortBy =>
      dispatch(
        SET_SORT_DATA({
          sortBy
        })
      ),
    setFilter: payload => dispatch(SET_FILTER(payload)),
    toggleSidebar: () => dispatch(TOGGLE_SIDEBAR()),
    updateLeadStatus: payload =>
      dispatch({
        type: UPDATE_LEAD_STATUS._REQUEST,
        payload
      }),
    downloadLeadList: () => dispatch({ type: DOWNLOAD_LEAD_LIST._REQUEST }),
    resetAdvancedSearch: () => dispatch(RESET_ADVANCED_SEARCH_FILTERS())
  })
)(Lead);
